import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useTranslation } from "react-i18next";
import { Mail } from "lucide-react";

interface VerificationCodeSentExplanationProps {
  sentTo: string | undefined;
}

export default function VerificationCodeSentExplanation({
  sentTo,
}: VerificationCodeSentExplanationProps) {
  const { t } = useTranslation();
  return (
    <Alert>
      <Mail className="w-5 h-5" />
      <AlertTitle>{t("resetPassword.verificationCodeSent")}</AlertTitle>
      <AlertDescription>
        {t("resetPassword.verificationCodeSentTo", { sentTo: sentTo || "" })}
      </AlertDescription>
    </Alert>
  );
}
